(() => {
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-gr-cart-discount]');
    if (!form) return;
    event.preventDefault();
    const code = new FormData(form).get('discount')?.toString().trim();
    if (!code) return;
    const root = window.Shopify?.routes?.root || '/';
    window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}cart`)}`);
  });
})();
